// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3cMKI","errorLogs":"EditorFooter_errorLogs__1-lS0"};